import {useFormContext} from '@yandex-delivery/form'
import React, {memo} from 'react'

import {appConfig} from 'src/shared/config'

import {FormMapUI} from './FormMapUI/FormMapUI'
import {useFormMap} from './hooks'
import type {Props} from './types'

export const OrderMap = memo<Props>(function OrderMap({dir, lang = 'ru_RU', location}) {
  const {zonePoint} = appConfig.initialProps
  const {watch} = useFormContext()
  const sourcePoint = watch('sourcePoint.address.coordinates')

  const {
    isDragPointAllowed,
    isRouteVisible,
    fetchTaxiSuggestHandler,
    orderPointsCoordinates,
    mapLocationResult,
    routePointCoordinates,
    sourcePointCoordinates,
  } = useFormMap({location: sourcePoint || zonePoint || location})

  return (
    <FormMapUI
      dir={dir}
      isDragPointAllowed={isDragPointAllowed}
      isRouteVisible={isRouteVisible}
      lang={lang}
      location={location}
      mapLocationResult={mapLocationResult}
      onPlacemarkChange={fetchTaxiSuggestHandler}
      orderPointsCoordinates={orderPointsCoordinates}
      routePointCoordinates={routePointCoordinates}
      sourcePointCoordinates={sourcePointCoordinates}
    />
  )
})
